import {
  ADMIN_PAYOUTS_LOADED,
  ADMIN_PAYOUTS_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
  setSubmissionLoaderLoading,
  setSubmissionLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

// --- Reducer corresponding actions ---
export function payoutsLoaded(payouts) {
  return {
    type: ADMIN_PAYOUTS_LOADED,
    payload: { payouts },
  };
}

export function payoutsClear() {
  return { type: ADMIN_PAYOUTS_CLEAR };
}

// --- API functions ---
async function fetchPayoutsApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'payouts',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function updatePayoutApi(token, id, updates, dispatch) {
  const response = await api.patch({
    path: `payouts/${id}`,
    version: 'gateway',
    token,
    body: updates,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function fetchPayoutHistoryApi(token, id, dispatch) {
  const response = await api.get({
    path: `payouts/${id}/history`,
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function triggerPayoutApi(token, id, dispatch) {
  const response = await api.post({
    path: `payouts/${id}/pay`,
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

// --- Public component actions ---
export function initiateFetchPayouts(params = {}) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const payouts = await fetchPayoutsApi(adminToken, params, dispatch);
      dispatch(payoutsLoaded(payouts));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function clearPayouts() {
  return (dispatch) => {
    dispatch(payoutsClear());
  };
}

export function initiateUpdatePayout(id, updates, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());
      await updatePayoutApi(adminToken, id, updates, dispatch);
      dispatch(arriveNotice('Payout entry updated successfully', 'ok'));
      if (onSuccess) onSuccess();
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setSubmissionLoaderReset());
    }
  };
}

export function initiateFetchPayoutHistory(id, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      const result = await fetchPayoutHistoryApi(adminToken, id, dispatch);
      if (onSuccess) onSuccess(result.data || []);
    } catch (e) {
      dispatch(arriveNotice(e.message));
    }
  };
}

export function initiateTriggerPayout(id, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());
      await triggerPayoutApi(adminToken, id, dispatch);
      dispatch(arriveNotice('Payout triggered successfully', 'ok'));
      if (onSuccess) onSuccess();
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setSubmissionLoaderReset());
    }
  };
}
